module.exports = __webpack_public_path__ + "static/media/level-2-blue.3d887b0d.svg";